// TODO: add support for video og tag; og:type also?
export const DEFAULT_META_TAGS = {
  description: import.meta.env.VITE_APP_DESCRIPTION,
  descriptionMaxLength: 160,
  image: '/og.png',
  keywords: import.meta.env.VITE_APP_KEYWORDS,
  title: import.meta.env.VITE_APP_NAME,
  titleMaxLength: 60,
  titleSuffixLength: ` - ${import.meta.env.VITE_APP_NAME}`.length,
}

// TODO: update schema?
export const DEFAULT_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': ['SoftwareApplication', 'WebApplication', 'MobileApplication'],
  applicationCategory: 'BusinessApplication',
  author: {
    '@type': 'Organization',
    description: import.meta.env.VITE_APP_DESCRIPTION,
    logo: `${import.meta.env.VITE_APP_FRONTEND_URL}/favicon.svg`,
    name: import.meta.env.VITE_APP_NAME,
    sameAs: [
      import.meta.env.VITE_SOCIAL_DISCORD,
      import.meta.env.VITE_SOCIAL_X,
      import.meta.env.VITE_SOCIAL_REDDIT,
      import.meta.env.VITE_SOCIAL_YOUTUBE,
      import.meta.env.VITE_SOCIAL_INSTAGRAM,
      import.meta.env.VITE_SOCIAL_TIKTOK,
      import.meta.env.VITE_SOCIAL_LINKEDIN,
    ],
    url: import.meta.env.VITE_PROMEET_URL,
  },
  description: import.meta.env.VITE_APP_DESCRIPTION,
  image: '/favicon.svg',
  name: import.meta.env.VITE_APP_NAME,
  offers: {
    '@type': 'Offer',
    price: 0,
  },
  operatingSystem: 'Any',
  sameAs: [
    import.meta.env.VITE_SOCIAL_DISCORD,
    import.meta.env.VITE_SOCIAL_X,
    import.meta.env.VITE_SOCIAL_REDDIT,
    import.meta.env.VITE_SOCIAL_YOUTUBE,
    import.meta.env.VITE_SOCIAL_INSTAGRAM,
    import.meta.env.VITE_SOCIAL_TIKTOK,
    import.meta.env.VITE_SOCIAL_LINKEDIN,
  ],
  url: import.meta.env.VITE_APP_FRONTEND_URL,
}
